// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CreateTable from './CreateTable/CreateTable';
import UploadImage from './UploadImage/UploadImage';

import type {SizeChart} from '../../duck';
type Props = {
  trigger: (name?: string) => Promise<boolean>,
  chartToEdit?: SizeChart,
  guideType: number,
  setStep: (v: number) => void,
  getValues: () => void,
};

export default function GuideSizeContent({guideType, ...otherProps}: Props) {
  switch (guideType) {
    case 0:
      return <CreateTable {...otherProps} />;
    case 1:
      return <UploadImage {...otherProps} />;
    default:
      return <div>Not implemented</div>;
  }
}

GuideSizeContent.propTypes = {
  trigger: PropTypes.func.isRequired,
  chartToEdit: PropTypes.object,
  guideType: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
};
